import React, { useState, useRef, useEffect, useCallback } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "react-toastify/dist/ReactToastify.css";
import service from "../services/authservices"
import { ScaleLoader } from 'react-spinners'
import moment from "moment";

const HistoryAll = () => {
    const [loader, setLoader] = useState(false);
    const [botBalance, setbotBalance] = useState([]);

    useEffect(() => { 
        fetchBalance();
    }, [0]);     

    const fetchBalance = async () => {
        setLoader(true)
        const response = await service.getExchangeBalance();
        if (response.status) {
            setLoader(false);
            setbotBalance(response.data);
        } else {
            console.error("Failed to fetch bot history:", response.Message);
            setLoader(false)
        }
    };

    return (
    <>
    <section>
        <Header />
    </section>
    <div className="withdraw-section">
    <div className="container">
        <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
                <Sidebar />
            </div>

            <div className="col-xl-9 col-lg-12 deposit_pad_top">
                <span className="profile_span">Exchanges Balance</span>
                <div className="col-md-12 col-lg-12 verfication_kyc_col">
                    <div className="pad-l-r">
                        <section className="asset_section asset_section_bottrade">
                            <>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="secuirty_box">
                                            <div className="secuirty_box_contentsub deposit_contentsub">
                                                <div className="table_section home_recent_table">
                                                    <div
                                                        className="table_boxcontainer"
                                                        style={{ height: "max-content" }}
                                                    >
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                <th>Exchange</th>
                                                                <th>Spot Balance (USDT)</th>
                                                                <th>Date & Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {loader ? (
                                                                    <tr>
                                                                        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                                                            <div className="loader_main loader_mainChange">
                                                                                <ScaleLoader color="#20A1FD" height={10} width={3} />
                                                                                <p>Loading...</p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ) : botBalance.length > 0 ? (
                                                                    botBalance[0].binance_status == true ? (
                                                                        <tr>
                                                                        <td>Binance</td>
                                                                        <td>{parseFloat(botBalance[0].binance_balance).toFixed(2)}</td>
                                                                        <td>{moment(botBalance[0].updated_at).format("lll")}</td>
                                                                        </tr>
                                                                    ) : 
                                                                    botBalance[0].kucoin_status == true ? (
                                                                        <tr>
                                                                        <td>Kucoin</td>
                                                                        <td>{parseFloat(botBalance[0].kucoin_balance).toFixed(2)}</td>
                                                                        <td>{moment(botBalance[0].updated_at).format("lll")}</td>
                                                                        </tr>
                                                                    ) : 
                                                                    botBalance[0].gateio_status == true ? (
                                                                        <tr>
                                                                        <td>Gate.io</td>
                                                                        <td>{parseFloat(botBalance[0].gateio_balance).toFixed(2)}</td>
                                                                        <td>{moment(botBalance[0].updated_at).format("lll")}</td>
                                                                        </tr>
                                                                    ) :
                                                                    botBalance[0].bybit_status == true ? (
                                                                        <tr>
                                                                        <td>Bybit</td>
                                                                        <td>{parseFloat(botBalance[0].bybit_balance).toFixed(2)}</td>
                                                                        <td>{moment(botBalance[0].updated_at).format("lll")}</td>
                                                                        </tr>
                                                                    ) : ("")
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="3" style={{ textAlign: "center" }}>
                                                                            <span className="depo_no_record">No Data Found</span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>

                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        </section>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    </>
  );
};

export default HistoryAll;
